import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '../../translations';
import { LockIcon } from '../../ui/icons';

// Plakietka „Premium” przy funkcji, której firma nie ma w planie (F.2). Funkcja premium jest
// widoczna jako zablokowana, nie znika (niezmiennik FAZY F). Tokeny ostrzeżenia mają osobne
// wartości dla trybu ciemnego (index.css), więc plakietka jest czytelna także w ciemnym menu.
const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  padding: 1px 7px;
  border-radius: var(--r-pill);
  border: 1px solid var(--warning-border);
  background: var(--warning-bg);
  color: var(--warning);
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: 0.02em;
  white-space: nowrap;
`;

export default function PremiumBadge({ className, style, 'data-cy': dataCy = 'premium-badge' }) {
  const { t } = useTranslation();
  return (
    <Pill className={className} style={style} title={t('premium.badgeTitle')} data-cy={dataCy}>
      <LockIcon size={11} aria-hidden="true" />
      {t('premium.badge')}
    </Pill>
  );
}
